import {
  Component,
  Input,
  ViewChild,
  ViewChildren,
  ElementRef,
  QueryList,
  AfterViewChecked,
  AfterViewInit,
  ChangeDetectorRef,
} from '@angular/core';
import {
  QuestionnaireSection,
  SectionQuestion,
} from './video-questionnaire.types';
import { HttpService } from '../../store/http/http.service';
import { ActivatedRoute } from '@angular/router';
import { APIConfig } from '../../api/api-config.provider';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { ResourceData } from '../../elements/resource/resource.types';

@Component({
  selector: 'app-video-questionnaire',
  templateUrl: './video-questionnaire.component.html',
  styleUrls: ['./video-questionnaire.component.scss'],
})
export class VideoQuestionnaireComponent
  implements AfterViewChecked, AfterViewInit
{
  /** Reference to the feedback textarea */
  @ViewChild('feedbackTextarea')
  feedbackTextarea?: ElementRef<HTMLTextAreaElement>;

  /** Reference to all video elements */
  @ViewChildren('videoElements')
  videoElements?: QueryList<ElementRef<HTMLVideoElement>>;
  messageSection = 0;
  /** Flag to track if we need to focus the textarea */
  private shouldFocusFeedback = false;

  /** Flag to track if we need to play a video */
  private shouldPlayVideo = false;

  /** Flag to track if videos have been initialized */
  private videosInitialized = false;

  /** Array of sections */

  get isMobile() {
    return window.innerWidth < 620;
  }

  get finallyMessage() {
    return 'Finally, tell us about a video <br/>you would love to post in the future';
    // return this.isMobile
    //   ? "Finally, if there's a <br/>video use-case you can think of, <br/> we would be happy to hear about it"
    //   : 'Finally, tell us about a video <br/>you would love to post in the future';
  }

  // Finally, if there's a video case you would love to post in the future, we would be happy to hear about it.

  get isNextEnabled() {
    return (
      this.answers[this.activeSectionIndex] !== undefined ||
      this.feedbackText.length > 0
    );
  }

  state: 'loading' | 'intro' | 'main' | 'use-cases' | 'finished' | 'error' =
    'loading';

  urlsbyKey = {
    'montage-1': 'https://private.cdn.inwedio.com/sample_video_montage.mov',
    'montage-2': 'https://private.cdn.inwedio.com/sample_video_animation_2.mov',
    'text-1': 'https://private.cdn.inwedio.com/sample_text_animation.mov',
    'text-2':
      'https://private.cdn.inwedio.com/sample_text_animation_fg_cut.mov',
    'product-1': 'https://private.cdn.inwedio.com/sample_mobile_app.mov',
    'product-2': 'https://private.cdn.inwedio.com/sample_mobile_app_2_cut.mov',
  };

  keys = [
    'montage-1',
    'montage-2',
    'text-1',
    'text-2',
    'product-1',
    'product-2',
  ];

  activeVideoIndex = 0;

  get currentVideoUrls() {
    return this.activeSection?.videoUrls || [];
  }

  get firstUrl() {
    const key = this.currentVideoUrls[0];
    return this.urlsbyKey[key];
  }

  @Input() sections: QuestionnaireSection[] = [
    {
      title: '1. Video Showcase',
      videoUrls: ['montage-1', 'montage-2'],
      videoSizes: [{ width: 1920, height: 1080, label: '1080p' }],
      questions: [
        {
          text: 'What is the main message of this video?',
          options: ['Option A', 'Option B', 'Option C'],
          answer: '',
        },
      ],
    },
    {
      title: '2. Text Animations',
      videoUrls: ['text-1', 'text-2'],
      videoSizes: [{ width: 1920, height: 1080, label: '1080p' }],
      questions: [
        {
          text: 'What is the main message of this video?',
          options: ['Option A', 'Option B', 'Option C'],
          answer: '',
        },
      ],
    },
    {
      title: '3. App Showcase',
      videoUrls: ['product-1', 'product-2'],
      videoSizes: [{ width: 1920, height: 1080, label: '1080p' }],
      questions: [
        {
          text: 'What is the main message of this video?',
          options: ['Option A', 'Option B', 'Option C'],
          answer: '',
        },
      ],
    },
  ];

  customToken$: Observable<string>;
  customToken: string;
  errorMsg = '';
  constructor(
    private readonly httpService: HttpService,
    private route: ActivatedRoute,
    private readonly apiConfig: APIConfig,
    private cdr: ChangeDetectorRef,
  ) {
    this.customToken$ = this.route.paramMap.pipe(
      map(pm => pm.get('customToken') || ''),
    );

    this.customToken$.subscribe(token => {
      if (token) {
        if (token == this.customToken) {
          return;
        }
        // -- // -- // -- // -- //
        this.customToken = token;
        this.loadProject(token);
      } else {
        this.customToken = null;
      }
    });
  }

  project: ResourceData;
  questionnaire: ResourceData;

  useCaseFinished() {
    console.log('useCaseFinished');
    this.setState('finished');
  }

  isDefined(object) {
    if (!object) {
      return false;
    }
    return Object.keys(object).length > 0;
  }
  loadProject(token: string) {
    this.httpService.httpClient
      .get(`${this.apiConfig.api.url}/customproject`, {
        headers: {
          Authorization: token,
        },
      })
      .subscribe({
        next: (response: any) => {
          console.log('response', response);

          this.project = response;
          this.questionnaire = this.project.relationships
            .questionnaire as ResourceData;
          const user = this.project.relationships.user as ResourceData;
          console.log('project', this.project);
          console.log('questionnaire', this.questionnaire);

          const responses = this.isDefined(
            this.questionnaire?.literals?.responses,
          );

          // return this.setState('use-cases');
          if (user?.IRI?.endsWith('c853e500-db85-11f0-a243-61ceedcc283d')) {
            return this.setState('intro');
          }

          // return;
          const useCase = this.isDefined(this.questionnaire?.literals?.useCase);
          if (responses && useCase) {
            this.setState('finished');
          } else if (responses) {
            this.setState('use-cases');
          } else {
            this.setState('intro');
          }
        },
        error: (error: any) => {
          console.error('Error loading project:', error);
          this.state = 'error';
          this.errorMsg = 'Something went wrong. Please try again later.';
        },
      });
  }

  /** Currently active section index */
  activeSectionIndex: number = 0;

  /** Currently active video index within the section */

  activeVideoKey = 'montage-1';
  /**
   * Gets the currently active section.
   */
  get activeSection(): QuestionnaireSection | null {
    return this.sections[this.activeSectionIndex] || null;
  }

  mainIntro = false;

  /**
   * Gets the currently active video URL.
   */
  get activeVideoUrl(): string | null {
    return this.urlsbyKey[this.activeVideoKey] || null;
  }

  /**
   * Navigates to a specific section by index.
   */
  // goToSection(index: number): void {
  //   if (index >= 0 && index < this.sections.length) {
  //     this.activeSectionIndex = index;
  //     this.activeVideoIndex = 0; // Reset video index when changing sections
  //   }
  // }

  /**
   * Navigates to a specific video within the current section.
   */

  /**
   * Checks if a video is active within the current section.
   */
  isVideoActive(key: string): boolean {
    return this.activeVideoKey === key;
  }

  /**
   * Handles video ended event - plays the next video.
   */
  getNextKey(): string {
    switch (this.activeVideoKey) {
      case 'montage-1':
        return 'montage-2';
      case 'montage-2':
        return 'montage-1';
      case 'text-1':
        return 'text-2';
      case 'text-2':
        return 'text-1';
      case 'product-1':
        return 'product-2';
      case 'product-2':
        return 'product-1';
    }
    this.shouldPlayVideo = true;
  }

  /**
   * Plays the active video and pauses all others.
   */
  private playActiveVideo(): void {
    // if (!this.videoElements) return;
    // const videos = this.videoElements.toArray();
    // const activeVideo = videos.find(
    //   videoRef => videoRef.nativeElement.src === this.activeVideoUrl,
    // );
  }

  /**
   * Navigates to the next section.
   */

  /**
   * Navigates to the previous section.
   */

  /**
   * Checks if a section is active.
   */
  isSectionActive(index: number): boolean {
    return this.activeSectionIndex === index;
  }

  /**
   * Selects an option for a question.
   */
  _selectOption(index: number): void {
    this.feedbackText = '';
    this.showFeedbackInput = false;
    this.answers[this.activeSectionIndex] = index;
    // Show the feedback textarea when an option is selected
  }

  sumissions: Record<string, any> = {};

  /** Flag to control answers section fade animation */
  answersFading = false;

  nextQuestion() {
    // -- //

    this.sumissions[this.activeSection.title] = {
      answer: this.answers[this.activeSectionIndex],
      feedback: this.feedbackText,
    };

    if (this.activeSectionIndex === this.sections.length - 1) {
      // console.log('sumissions', this.sumissions);
      this.submit();
      return;
    }

    // Start fade-out animation
    this.answersFading = true;

    // Update to next question while hidden
    this.activeSectionIndex++;
    this.activeVideoIndex = 0;
    this.feedbackText = '';
    this.showFeedbackInput = false;
    const nextKey = this.activeSection.videoUrls[0];
    this.playByKey(nextKey);
    // this.goToVideo(this.currentVideoUrls[0]);
    // Small delay before fade-in to ensure DOM updates
    setTimeout(() => {
      this.answersFading = false;
    }, 500);
    // }, 300); // Match the CSS transition duration
  }

  submit() {
    this.setState('use-cases');
    this.httpService.httpClient
      .patch(
        `${this.apiConfig.api.url}/customproject`,
        {
          questionnaireIRI: this.questionnaire.IRI,
          responses: this.sumissions,
        },
        {
          headers: {
            Authorization: this.customToken,
          },
        },
      )
      .subscribe({
        next: (response: any) => {
          console.log('response', response);
        },
        error: (error: any) => {
          console.error('Error loading project:', error);
        },
      });
  }

  answers: number[] = [];

  /** Whether the custom feedback textarea is shown */
  showFeedbackInput = false;
  /** Custom feedback text */
  feedbackText = '';

  get secondIsShown() {
    return this.activeVideoIndex === 1;
  }

  get firstIsShown() {
    return this.activeVideoIndex === 0;
  }

  /**
   * Toggles the custom feedback textarea.
   */
  toggleFeedbackInput(): void {
    this.answers[this.activeSectionIndex] = undefined;
    this.showFeedbackInput = !this.showFeedbackInput;
    if (this.showFeedbackInput) {
      this.shouldFocusFeedback = true;
    }
  }

  @ViewChild('firstVideo', { static: false })
  firstVideo?: ElementRef<HTMLVideoElement>;
  @ViewChild('secondVideo', { static: false })
  secondVideo?: ElementRef<HTMLVideoElement>;

  private setSrc(el: HTMLVideoElement, src: string) {
    // console.log('setSrc', src);
    if (el.src === src) return;
    el.src = src;
    el.load();
  }

  get firstName() {
    return (this.project?.relationships?.user as ResourceData)?.literals
      ?.firstName;
  }

  get currentVideoUrl() {
    return this.urlsbyKey[this.activeVideoKey];
  }

  setState(state: 'loading' | 'intro' | 'main' | 'use-cases' | 'finished') {
    this.state = state;

    switch (state) {
      case 'intro':
        break;
      case 'main':
        this.mainIntro = true;
        this.started = false;
        setTimeout(() => {
          this.mainIntro = false;
          this.playByKey('montage-1');
          // Wait until Angular finished rendering the video elements
          // this.zone.onStable.pipe(/* take(1) */).subscribe(() => {
          //   this.startVideoFlow();
          // });
        }, 2500);
        break;

      case 'use-cases':
        setTimeout(() => {
          this.messageSection = 1;
          setTimeout(() => {
            this.messageSection = 2;
          }, 4_000);
        }, 2_000);
        break;
    }
  }

  async ngAfterViewInit(): Promise<void> {}

  ngAfterViewChecked(): void {
    if (this.started) return;
    if (this.state !== 'main') return;
    if (this.mainIntro) return;

    const el = this.firstVideo?.nativeElement;
    if (!el) return;

    this.started = true;
    this.startVideoFlow();
  }

  started = false;

  async startVideoFlow() {
    const player = this.firstVideo?.nativeElement;
    console.log('startVideoFlow', player);
    if (!player) return;

    // set current
    // this.setSrc(player, this.activeVideoUrl!);
    await this.playCurrent();

    // preload next
    // this.warmNext();
  }

  goToVideo(key: string) {
    this.activeVideoKey = key;

    const player = this.firstVideo?.nativeElement;
    if (!player) return;

    this.setSrc(player, this.activeVideoUrl!);
    this.playCurrent();
  }

  playCurrent() {
    const player = this.firstVideo?.nativeElement;
    if (!player) return;
    player.play();
  }

  async onVideoEnded() {
    const video = this.firstVideo?.nativeElement;
    if (!video) return;

    video.pause();

    const nextKey = this.getNextKey();
    console.log('onVideoEnded', nextKey);
    this.playByKey(nextKey);
  }

  playReq = 0;
  async playByKey(key: string) {
    const req = ++this.playReq;

    this.activeVideoKey = key;

    // Force Angular to push the new [src] into the DOM now
    this.cdr.detectChanges();

    const video = this.firstVideo?.nativeElement;
    if (!video) return;

    const expected = this.activeVideoUrl!; // the URL for "key"

    // 1) Wait until the element's currentSrc/src is actually the expected one
    await this.waitForSrc(video, expected, req);

    // 2) Wait until the browser has the first frame for that src
    await this.waitForEvent(video, 'loadeddata', req);

    // 3) Play (and always catch)
    try {
      await video.play();
    } catch (e: any) {
      if (e?.name !== 'AbortError') console.error('play failed', e);
    }
  }

  waitForSrc(video: HTMLVideoElement, expected: string, req: number) {
    return new Promise<void>(resolve => {
      const check = () => {
        if (req !== this.playReq) return resolve(); // newer request took over

        const cur = video.currentSrc || video.src; // currentSrc is more reliable
        if (cur === expected) return resolve();

        requestAnimationFrame(check);
      };
      check();
    });
  }

  private waitForEvent(
    video: HTMLVideoElement,
    eventName: 'loadeddata' | 'canplay',
    req: number,
  ) {
    // If already ready, don't wait
    if (video.readyState >= HTMLMediaElement.HAVE_CURRENT_DATA) {
      return Promise.resolve();
    }

    return new Promise<void>(resolve => {
      const done = () => {
        video.removeEventListener(eventName, done);
        resolve();
      };

      const cancel = () => {
        video.removeEventListener(eventName, done);
        resolve();
      };

      video.addEventListener(eventName, done);
      // If a newer play request starts, stop waiting
      const id = setInterval(() => {
        if (req !== this.playReq) {
          clearInterval(id);
          cancel();
        }
      }, 50);
    });
  }

  /**
   * AfterViewInit lifecycle hook - starts playing the first video.
   */

  /**
   * AfterViewChecked lifecycle hook - focuses textarea and plays video when needed.
   */

  selectOption(question: SectionQuestion, option: string): void {
    //question.answer = option;
  }

  /**
   * Checks if an option is selected.
   */
  isOptionSelected(question: SectionQuestion, option: string): boolean {
    return question.answer === option;
  }
}
